module.exports = __webpack_public_path__ + "img/confirmed-baby.0eb9e7cd.png";